import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { get, replace, trim } from 'lodash/fp';
import TextField from '../TextField';

const format = value => (value.length > 10
  ? trim(`${value.substring(0, 3)} ${value.substring(3, 7)} ${value.substring(7, 11)}`)
  : trim(`${value.substring(0, 3)} ${value.substring(3, 6)} ${value.substring(6, 10)}`));

const S = {
  TextField: styled(({ InputLabelProps, ...otherProps }) => (
    <TextField
      InputLabelProps={{
        ...InputLabelProps,
        classes: { root: 'label-root' },
      }}
      {...otherProps}
    />
  ))`
    width: 100%;
    margin: 0;
    font-size: ${({ theme }) => theme.typography.pxToRem(15)};
    .label-root {
      font-size: ${({ theme }) => theme.typography.pxToRem(15)};
    }
    .MuiOutlinedInput-notchedOutline {
      border-color: ${({ theme }) => theme.palette.grey[300]};
    }
  `,
};

const PhoneNumberField = ({
  className, field: { value, onChange, ...field }, form, ...otherProps
}) => {
  const error = useMemo(() => !!(
    get(field.name, form.errors) && get(field.name, form.touched)
  ), [field.name, form.errors, form.touched]);

  const handleChange = useCallback((event) => {
    onChange(Object.assign(event, {
      target: Object.assign(event.target, { value: replace(/\D/g, '', event.target.value) }),
    }));
  }, [onChange]);

  return (
    <S.TextField
      type="tel"
      margin="dense"
      variant="outlined"
      error={error}
      value={format(value)}
      onChange={handleChange}
      {...field}
      {...otherProps}
    />
  );
};

PhoneNumberField.propTypes = {
  className: PropTypes.string,
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string,
      PropTypes.shape({}),
    ]).isRequired,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
  }).isRequired,
  form: PropTypes.shape({
    errors: PropTypes.shape({
      school: PropTypes.string,
    }).isRequired,
    touched: PropTypes.shape({
      school: PropTypes.bool,
    }).isRequired,
  }).isRequired,
};

PhoneNumberField.defaultProps = {
  className: undefined,
};

export default PhoneNumberField;
